/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pxk_Sp_Scan_Pick_ButtonInputs */

const vi_pxk_sp_scan_pick_button = /** @type {(inputs: Pxk_Sp_Scan_Pick_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quét lô`)
};

/**

* @param {Pxk_Sp_Scan_Pick_ButtonInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pxk_sp_scan_pick_button = /** @type {((inputs?: Pxk_Sp_Scan_Pick_ButtonInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pxk_Sp_Scan_Pick_ButtonInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pxk_sp_scan_pick_button(inputs)
});